import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { motion, AnimatePresence } from "framer-motion";

const ImagePreviewOverlay = ({ preview, onClose }) => {
  return (
    <AnimatePresence>
      {preview && (
        <Box
          component={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          onClick={onClose}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: "rgba(0,0,0,0.7)",
            zIndex: 1300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(4px)",
          }}
        >
          <Box
            component={motion.div}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={(e) => e.stopPropagation()}
            sx={{
              position: "relative",
              bgcolor: "#FFFFFF",
              borderRadius: 3,
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
              maxWidth: "90vw",
              maxHeight: "80vh",
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                width: 28,
                height: 28,
                bgcolor: "rgba(0,0,0,0.5)",
                color: "#FFFFFF",
                zIndex: 1,
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: "rgba(0,0,0,0.7)",
                },
              }}
            >
              <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>
            <Box
              component="img"
              src={preview.url}
              alt={preview.file?.name}
              sx={{
                display: "block",
                maxWidth: 450,
                maxHeight: "70vh",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      )}
    </AnimatePresence>
  );
};

export default ImagePreviewOverlay;
